import React, { FC } from "react";
import { FeeEarnerRow } from "./fee-earners-row";
import { List, Button } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { Work, TeamMembershipIds } from "../../data-types";
import styles from "./fee-earner-list.module.css";
import { useTaxonomyLabel } from "~/context/taxonomy-context";
import { TeamMembershipPartsFragment } from "~/gql/graphql";
const { ["list-item"]: listItemClassName, ["add-fee-button"]: addFeeButtonClassName } =
  styles as any;

type Props = {
  work?: Work[] | null;
  onUpdate: (work: Work, timeEntryUpdate: boolean) => void;
  onDelete: (id: number) => void;
  onCreate: () => void;
  onCopyFromPreviousPhase?: () => void;
  range?: boolean;
  currencySymbol: string;
  teamMembers: TeamMembershipPartsFragment[];
  includedTeamMemberships: TeamMembershipIds[];
  matterId: number;
};

export const FeeEarnerList: FC<Props> = ({
  work,
  onDelete,
  onUpdate,
  onCreate,
  range = false,
  currencySymbol,
  teamMembers,
  includedTeamMemberships,
  matterId,
}) => {
  const taxonomy = useTaxonomyLabel();

  return (
    <>
      <Button
        size="small"
        type="primary"
        icon={<PlusOutlined />}
        onClick={onCreate}
        className={addFeeButtonClassName}
      >
        Add {taxonomy.FeeEarner}
      </Button>
      <List
        dataSource={work || []}
        rowKey="id"
        split
        renderItem={(item) => (
          <List.Item key={item.id} className={listItemClassName}>
            <FeeEarnerRow
              currencySymbol={currencySymbol}
              work={item}
              onDeleteWork={onDelete}
              onUpdateWork={onUpdate}
              range={range}
              teamMembers={teamMembers}
              includedTeamMemberships={includedTeamMemberships}
              matterId={matterId}
            />
          </List.Item>
        )}
      />
    </>
  );
};
